module.exports = __webpack_public_path__ + "img/expert_avatar_bg.8b40926.png";